// src/app/routes.js
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import withRouter from '../hooks/withRouter'
import { Home } from '../pages/home'
import { Blog } from '../pages/blog'
import { BlogPost } from '../pages/blog/BlogPost'
import { Projects } from '../pages/projects'
import { ProjectViewer } from '../pages/projects/ProjectViewer'
import { Socialicons } from '../components/socialicons'
import { TransitionGroup } from 'react-transition-group'

const AnimatedRoutes = withRouter(({ location }) => (
  <TransitionGroup>
    <Routes location={location}>
      <Route exact path='/' element={<Home />} />
      <Route path='/blog' element={<Blog />} />
      <Route path='/blog/:slug' element={<BlogPost />} />
      <Route path='/projects' element={<Projects />} />
      <Route path='/projects/:projectId' element={<ProjectViewer />} />{' '}
    </Routes>
  </TransitionGroup>
))

function AppRoutes() {
  return (
    <div className='s_c'>
      <AnimatedRoutes />
      <Socialicons />
    </div>
  )
}

export default AppRoutes
